module.exports = __webpack_public_path__ + "static/img/photo05.5d10747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hakodate/photo05.jpg
// module id = zU//
// module chunks = 0